import Swal from "sweetalert2";
import api from "../../services/api";

export const exportConsumidorDetallado = async (fromDate, toDate) => {
  try {
    if (!fromDate || !toDate) {
      return Swal.fire("Atención", "Debes seleccionar un rango de fechas para exportar", "warning");
    }

    Swal.fire({
      title: "Generando Excel...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const response = await api.post(
      "/invoices/export-consumidor-detallado",
      { from: fromDate, to: toDate },
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const fechaInicio = fromDate.replace(/-/g, "_");
    const fechaFin = toDate.replace(/-/g, "_");
    link.download = `detallado_consumidor_${fechaInicio}_al_${fechaFin}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    Swal.fire({ icon: "success", title: "¡Descarga Completa!", timer: 3000, showConfirmButton: false });
  } catch (error) {
    Swal.fire({ icon: "error", title: "Error", text: "No se pudo completar la exportación" });
  }
};